// Project-specific design token extensions.
// Values not in design/tokens.json (Figma source) but used widely in the codebase.
// Promote to Figma when designer is available; until then, this is the canonical home.
//
// Naming convention:
//   - spacing: continue Figma's "<unit>" / "<unit>_<fraction>" scheme
//   - radii:   continue "radius-<px>" scheme
//   - typography: extend `paragraph` group with descriptive keys
import {
  colors as baseColors,
  spacing as baseSpacing,
  radii as baseRadii,
  typography as baseTypography,
  shadows as baseShadows,
} from './tokens';

export const colors = baseColors;
export const shadows = baseShadows;

export const spacing = {
  ...baseSpacing,
  absolute: {
    ...baseSpacing.absolute,
    "px": 1,    // 1px hairline (borderWidth)
    "3_5": 14,  // form input vertical padding
    "4_5": 18,  // dropdown / icon button padding
  },
} as const;

export const radii = {
  ...baseRadii,
  absolute: {
    ...baseRadii.absolute,
    "radius-5": 5,
    "radius-7": 7,
    "radius-20": 20,
  },
} as const;

export const typography = {
  ...baseTypography,
  paragraph: {
    ...baseTypography.paragraph,
    "paragraph extra-small font size": 13,  // form labels
    "paragraph caption font size": 11,       // helper / hint text
    "paragraph subheading font size": 18,    // section subtitles
  },
} as const;

// Same shape as base tokens namespace, with extensions merged in.
export const tokens = {
  colors,
  spacing,
  radii,
  typography,
  shadows,
} as const;

export type Tokens = typeof tokens;
export type Colors = typeof colors;
export type Spacing = typeof spacing;
export type Radii = typeof radii;
export type Typography = typeof typography;
export type Shadows = typeof shadows;
